import { TLocation, getRandomLocation, getStartLocation } from '../locations/location.generators';
import { ImmerStateCreator } from './store.types';

type TLocationState = {
   state: {
      currentLocation: TLocation;
      daysVentured: number;
      mostDaysVentured: number;
   };
};

type TLocationActions = {
   actions: {
      setActiveLocation(params: { location: TLocation }): void;
      setActiveRandomLocation: () => void;
      setLocationCompleted(): void;
      setDaysVentured(newDays: number): void;
      setToStartLocation(): void;
   };
};

type TLocationSlice = TLocationState & TLocationActions;
export type TNamedLocationSlice = { location: TLocationSlice };

export const getLocationInitialState = (): TLocationState['state'] => {
   return {
      currentLocation: getStartLocation(),
      daysVentured: 0,
      mostDaysVentured: 0,
   }
};

export const createLocationSlice: ImmerStateCreator<TNamedLocationSlice, TLocationSlice> = (set, get, store) => ({
   /***************************
    * State
    ***************************/
   state: getLocationInitialState(),

   /***************************
    * Actions
    ***************************/
   actions: {
      setActiveLocation: ({ location }) => {
         return set((state) => {
            state.location.state.currentLocation = location;
         });
      },
      setActiveRandomLocation: () => {
         return set((state) => {
            state.location.state.currentLocation = getRandomLocation();
         });
      },
      setLocationCompleted: () => {
         return set((state) => {
            state.location.state.currentLocation.completed = true;
         });
      },

      setDaysVentured(newDays: number) {
         return set((state) => {
            state.location.state.daysVentured = newDays;
            if (newDays > state.location.state.mostDaysVentured) {
               state.location.state.mostDaysVentured = newDays;
            }
         });
      },
      setToStartLocation() {
         return set((state) => {
            state.location.state.currentLocation = getStartLocation();
         });
      },
   },
});
